module.exports = "/assets/2ff82275809cc14d4442e499204c7887.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ZL.png
// module id = 2068
// module chunks = 0